/**
 * useOnlineStatus.ts
 * A16 : détecte l'état réseau du navigateur en temps réel.
 *
 * - Retourne `true` si la connexion est disponible, `false` si hors ligne.
 * - Écoute les événements `online` / `offline` pour des mises à jour réactives.
 * - Exposé comme singleton via un module-level BroadcastChannel-like pattern
 *   (les hooks dans des composants différents partagent la même valeur).
 */
import { useEffect, useState } from 'react';

export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState<boolean>(() => navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
